<template>
  <div>
      <el-input v-if="type == 'text'" class="with" :disabled="disabled" v-model="inputValue" @input="onInput" :placeholder="placeholder || '请输入' + form.name"></el-input>
      <el-input v-if="type == 'number'" type="number" class="with" :disabled="disabled" v-model="inputValue" @input="onInput" :placeholder="placeholder || '请输入' + form.name"></el-input>
      <el-input v-if="type == 'textarea'" type="textarea" class="with" :disabled="disabled" v-model="inputValue" @input="onInput" :placeholder="placeholder || '请输入' + form.name"></el-input>
      <el-select v-if="type == 'select'" :clearable="clearable" :disabled="disabled" v-model="inputValue" class="with" @change="onInput" :placeholder="placeholder || '请选择' + form.name">
        <el-option v-for="item in select" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-date-picker v-if="type == 'date'" :disabled="disabled" @change="onInput" v-model="inputValue" type="date" class="with" :placeholder="placeholder || '请选择' + form.name"> </el-date-picker>
      <el-date-picker v-if="type == 'dateSpan'" :disabled="disabled" v-model="inputValue" @change="onInput" class="with" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-time-select v-if="type == 'time'" :disabled="disabled" @change="onInput" v-model="inputValue"  class="with" :placeholder="placeholder || '请选择' + form.name"></el-time-select>
      <el-date-picker v-if="type == 'datetime'" :disabled="disabled" @change="onInput" v-model="inputValue" type="datetime" class="with" :placeholder="placeholder || '请选择' + form.name"></el-date-picker>
      <el-upload v-if="type == 'img'" :disabled="disabled" accept="image/*" :action="uploadAction" :headers="uploadHeader" :on-preview="Preview" :before-remove="Remove" :on-success="Success" :file-list="inputValue" list-type="picture-card">
          <el-button size="small" type="primary">点击上传</el-button><div slot="tip" class="el-upload__tip">只能上传jpg/png/bmp/gif/jpeg文件，且不超过10M</div>
      </el-upload>
      <el-upload v-if="type == 'file'" :disabled="disabled" :action="uploadAction" :headers="uploadHeader" :on-preview="Preview" :before-remove="Remove" :on-success="Success" :file-list="inputValue">
          <el-button size="small" type="primary">点击上传</el-button><div slot="tip" class="el-upload__tip">文件大小不超过10M</div>
      </el-upload>
      <div v-if="type == 'mailList'">
        <el-button @click="CheckUser" :disabled="disabled">{{placeholder || '+'}}</el-button>
      </div>
      <div v-if="type == 'rate'">
          <el-rate v-model="inputValue" :disabled="disabled" @change="onInput"></el-rate>
      </div>
      <el-switch v-if="type == 'switch'" @change="onInput"  :disabled="disabled" v-model="inputValue" ></el-switch>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        inputValue: this.value,
        uploadAction: "",
        uploadHeader: {}
      }
    },
    props: {
      form: { type: Object, default () { return {}; } },
      type: { type: String, default: "text" },
      value: {},
      disabled: { type: Boolean, default: false },
      placeholder: { type: String, default: "" },
      select: { type: Array, default () { return []; } },
      multiple: { type: Boolean, default: false },
      checkType: { type: Number, default: 0 },
      clearable: { type: Boolean, default: false }
    },
    created () {
      if (this.type == "mailList") {
        this.inputValue = this.inputValue ? (this.multiple ? JSON.stringify(this.inputValue) : [JSON.stringify(this.inputValue)]) : [];
      } else if (this.type == "dateSpan") {
        this.inputValue = this.inputValue ? this.inputValue : [];
      } else if (this.type == "img" || this.type == "file") {
        this.inputValue = this.inputValue || [];
        var data = JSON.parse(this.$tool.ss.Get(this.$config.LoginToken));
        this.uploadHeader = { Authorization: data.type + " " + data.token };
        this.uploadAction = this.Ajax.axios.defaults.baseURL + "/api/UpLoad/UploadFile";
      } else if (this.type == "switch") {
        this.inputValue = this.inputValue ? this.inputValue : false;
      } else if (this.type == "rate") {
        this.inputValue = this.inputValue ? this.inputValue : 0;
      } else {
        this.inputValue = this.inputValue ? this.inputValue : "";
      }
    },
    mounted () {
    },
    methods: {
      onInput () {
        if (this.type == "number") {
          this.$emit('valueChange', this.form.param, parseFloat(this.inputValue), this.form);
        } else {
          this.$emit('valueChange', this.form.param, this.inputValue, this.form);
        }

      },
      Preview (file) {
        if (this.type == "img") {
          const h = this.$createElement;
          this.$msgbox({
            title: '预览',
            message: h('img', { style: { width: "400px" }, attrs: { src: file.url } }),
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done();
            }
          }).then(() => { }).catch(() => { });
        } else {
          if (file.response) {
            window.open(this.Ajax.axios.defaults.baseURL + file.response.data)
          } else {
            window.open(file.url)
          }
        }
      },
      Remove (file, fileList) {
        var files = [];
        fileList.forEach(item => {
          if (item.uid != file.uid) {
            files.push({
              name: item.name,
              url: this.Ajax.axios.defaults.baseURL + item.response.data
            })
          }
        });
        this.$emit('valueChange', this.form.param, files, this.form);
      },
      Success (response, file, fileList) {
        var files = [];
        fileList.forEach(item => {
          files.push({
            name: item.name,
            url: this.Ajax.axios.defaults.baseURL + item.response.data
          })
        });
        this.$emit('valueChange', this.form.param, files, this.form);
      },
      CheckUser () {
        var set = {
          type: this.checkType,//类型0默认全部 1 部门 2 人员
          CheckType: this.multiple ? 1 : 0,//选择类型 0单选 1多选
          CheckList: this.inputValue ? (this.multiple ? this.inputValue : [this.inputValue]) : [],//已选人员
        };
        this.$parent.$parent.$parent.$parent.MailSet = set;
        this.$parent.$parent.$parent.$parent.MailAction = this.inputUser;
        this.$parent.$parent.$parent.$parent.ShowMail = true;
      },
      inputUser (dt) {
        this.$emit('valueChange', this.form.param, dt, this.form);
      }
    },
  }
</script>
<style scoped>
  .with {
    width: 90%;
  }
</style>